import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';

import * as styles from './DividerLine.css';

export const DividerLine = ({ children }: PropsWithChildren) => {
  const { isDarkMode } = useSiteTheme();
  return (
    <div className={styles.dividerLine}>
      <span
        className={clsx(styles.dividerLineBar, {
          [styles.dividerLineBarDark]: isDarkMode,
        })}
      />
      <div
        className={clsx(styles.contentContainer, {
          [styles.contentContainerDark]: isDarkMode,
        })}
      >
        {children}
      </div>
      <span
        className={clsx(styles.dividerLineBar, {
          [styles.dividerLineBarDark]: isDarkMode,
        })}
      />
    </div>
  );
};
